import Vue from 'vue'
import router from './router'
import store from './store'
// import NProgress from 'nprogress' // progress bar
// import 'nprogress/nprogress.css' // progress bar style
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { generateIndexRouter } from '@/utils/util'
import versionTood from '@/utils/versionUpdate'

//// NProgress Configuration
//NProgress.configure({
//  showSpinner: false
//})

// no redirect whitelist
const whiteList = [
  '/user/login',
  '/404',
  '/403',
  '/500'
]

router.beforeEach((to, from, next) => {
  //判断当前代码版本是否与服务器中代码版本一致，如不一致则刷新页面获取最新
  if (to.fullPath == '/503') {
    next()
    return
  } else {
    versionTood.isNewVersion()
  }

  // remove resize-for-mobile
  if (document.querySelector('.router-view-wrapper')) {
    document.querySelector('.router-view-wrapper').classList.remove('resize-for-mobile')
  }

  //if (to.name != 'login') {
  //  // start progress bar
  //  NProgress.start()
  //}

  if (whiteList.indexOf(to.path) !== -1) {
    // 在免登录白名单，直接进入
    next()
  } else if (to.path === '/') {
    next({
      path: '/user/login'
    })
    //NProgress.done()
  } else if (Vue.ls.get(ACCESS_TOKEN) && sessionStorage['Access-Token']) {
    /* has token */
    if (to.path === '/user/login') {
      next({
        path: '/dashboard/analysis'
      })
      //NProgress.done()
    } else {
      if (store.getters.permissionList.length === 0) {
        store
          .dispatch('GetPermissionList')
          .then(res => {
            const menuData = res.result.menu
            if (menuData === null || menuData === '' || menuData === undefined) {
              return
            }
            let constRoutes = []
            constRoutes = generateIndexRouter(menuData)
            // 添加主界面路由
            store
              .dispatch('UpdateAppRouter', {
                constRoutes
              })
              .then(() => {
                // 根据roles权限生成可访问的路由表
                // 动态添加可访问路由表
                router.addRoutes(store.getters.addRouters)
                const redirect = decodeURIComponent(from.query.redirect || to.path)
                if (to.path === redirect) {
                  // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
                  next({
                    ...to,
                    replace: true
                  })
                } else {
                  // 跳转到目的路由
                  next({
                    path: redirect
                  })
                }
              })
          })
          .catch(() => {
            /* notification.error({
               message: '系统提示',
               description: '请求用户信息失败，请重试！'
             })*/
            store.dispatch('Logout').then(() => {
              // next({ path: '/user/login', query: { redirect: to.fullPath } })
              next({
                path: '/403'
              })
            })
          })
      } else {
        next()
      }
    }
  } else {
    next({
      path: '/user/login'
    })
    //NProgress.done()
  }
})

router.afterEach(() => {
  //// finish progress bar
  //NProgress.done()
})

